import React from 'react';

const EmailAccountsModal = ({
  open,
  onClose,
  alertVariant,
  status,
  loadingAccounts,
  accounts,
  onNew,
  onEdit
}) => {
  if (!open) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}>
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Cuentas de email</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p className="text-muted">IMAP/SMTP, remitente y firma para lectura y envío.</p>
            {status && (
              <div className={`alert alert-${alertVariant(status.type)}`}>
                {status.message}
              </div>
            )}
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className="text-muted small">{loadingAccounts ? 'Cargando cuentas...' : `${accounts.length} cuentas configuradas`}</div>
              <button className="btn btn-primary btn-sm" onClick={onNew}>
                Nueva cuenta
              </button>
            </div>
            {loadingAccounts ? (
              <p>Cargando cuentas...</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>From</th>
                      <th>Activa</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {accounts.length ? (
                      accounts.map((acc) => (
                        <tr key={acc.id}>
                          <td>{acc.name}</td>
                          <td>{acc.from_email}</td>
                          <td>{acc.active ? 'Sí' : 'No'}</td>
                          <td>
                            <button className="btn btn-link btn-sm" onClick={() => onEdit(acc)}>
                              Editar
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr><td colSpan="4">No hay cuentas configuradas.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailAccountsModal;
